import { Controller } from "@hotwired/stimulus";

import Tablesort from "../utils/setupTablesort.js";

export default class extends Controller {
  static values = {
    ascClass: { type: String, default: 'sorted ascending' },
    descClass: { type: String, default: 'sorted descending' },
    hideEmpty: { type: Boolean, default: false },

    initialColumn: Number,
    initialDirection: { type: String, default: 'asc' }
  }

  connect() {
    if (this.element.tagName !== 'TABLE') {
      console.warn("Stimulus [table-sort] should be connected to a <table> element.");
      return
    }

    this.tablesort = new Tablesort(this.element, { hideEmpty: this.hideEmptyValue });

    this._applyInitialSort();
  }

  toggleHideEmpty(event) {
    this.hideEmptyValue = event.target.checked; // keep Stimulus value in sync
    this.tablesort.options.hideEmpty = this.hideEmptyValue;

    // re-run sorting with updated option
    this.tablesort.refresh();
  }

  _applyInitialSort() {
    if (!this.hasInitialColumnValue) return

    const headers = this.element.querySelectorAll("thead th")
    const th = headers[this.initialColumnValue]

    if (!th) return

    // First click sorts ascending
    th.click()

    // Second click flips to descending if requested
    if (this.initialDirectionValue === 'desc') {
      th.click()
    }
  }


  _clearSortClasses() {
    const headers = this.element.querySelectorAll("thead th")
    headers.forEach(th => {
      th.classList.remove(this.ascClassValue.split(" "), this.descClassValue.split(" "))
    })
  }

  _setSortClass(th, direction) {
    if (!th) return
    if (direction === 'asc') {
      th.classList.add(this.ascClassValue)
    } else {
      th.classList.add(this.descClassValue)
    }
  }

  // TODO: Allow the element to be a target

}
